<template>
  <div class="signIn">
    <van-nav-bar
      :title="$t('m.jl_span2')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content">
      <div class="signIn_list" v-if="signInList">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('m.gengduo')"
          @load="onLoad"
        >
          <div class="item" v-for="(item, index) in signInList" :key="index">
            <div style="flex:1;">
              <span class="line-clamp2" style="font-size:12px;">{{
                item.goods_name
              }}</span>
              <span style="font-size:10px;"
                >{{ $t("m.dj_span5") }}：{{ item.money }}
                <span style="margin-left:10px; font-size:10px;"
                  >{{ $t("m.tz_span1") }}：{{ item.oid }}</span
                ></span
              >

              <span style="font-size:10px;"
                >{{ $t("m.jl_span8") }}：{{ item.created_at }}</span
              >
            </div>
            <div>
              <span
                style="width:60px;text-align:right;margin-left:10px;font-size:12px;"
                >{{
                  item.status == -1
                    ? $t("m.jl_span9")
                    : item.status == 1
                    ? $t("m.jl_span10")
                    : $t("m.jl_span11")
                }}</span
              >
            </div>
          </div>
        </van-list>
      </div>
      <van-empty
        v-if="!signInList"
        class="custom-image"
        :image="emptyImg"
        :description="$t('m.gengduo')"
      />
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
export default {
  name: "",
  data() {
    return {
      emptyImg: require("../../assets/images/kong.png"),
      signInList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0
    };
  },
  mounted() {
    this.$toast.loading({
      message: "数据加载中...",
      forbidClick: true,
      duration: 500
    });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;
      request
        .get("/shop/integral/log", { page: _this.page }, { login: true })
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.list.length; i++) {
            this.signInList.push({
              goods_name: res.data.data.list[i]["goods"]["title"],
              money: res.data.data.list[i]["goods"]["price"],
              created_at: res.data.data.list[i]["created_at"],
              oid: res.data.data.list[i]["oid"],
              status: res.data.data.list[i]["status"]
            });
          }
          this.loading = false;
          if (res.data.data.list.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.error(err.response.data.msg);
        });
    }
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.signIn /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: var(--bg-color);
}
.signIn /deep/ .van-nav-bar__title {
  color: #fff;
}
.signIn /deep/ .van-icon {
  color: #fff;
}
.signIn {
  .content {
    padding: 0 12px;
    .signIn_title {
      margin: 25px 0;
    }
    .signIn_btn {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 110px;
      background-image: url(../../assets/images/bg3.png);
      div {
        width: 220px;
        padding: 10px 0;
        border-radius: 20px;
        text-align: center;
        background-color: #fff;
      }
    }
    .sigIn_list_title {
      margin: 20px 0 5px;
    }
    .signIn_list {
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0px 10px 0;
        border-bottom: 1px solid #f2f2f2;
        div:nth-child(1) {
          display: flex;
          flex-direction: column;
          span:nth-child(1) {
            margin-bottom: 3px;
            font-size: 14px;
          }
          span:nth-child(2) {
            font-size: 12px;
            color: #666;
          }
          span:nth-child(3) {
            font-size: 12px;
            color: #999;
          }
          span:nth-child(4) {
            font-size: 12px;
            color: #999;
          }
        }
        div:nth-child(2) {
          font-weight: bold;
          color: #ed4032;
          span:nth-child(1) {
            vertical-align: text-top;
          }
        }
      }
    }
    .finish_text {
      padding: 10px 0;
      font-size: 12px;
      color: #666;
      text-align: center;
    }
  }
}
</style>
